import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../context/admin";
import Modal from "../../common/Modal";
import GeneralInput from "../../common/GeneralInput";
import AdminService from "../../../services/admin.service";
import { useGlobal } from "../../../context/global";

export default function EditCost() {
    const { setMessage } = useGlobal()
    const { editCostData, setEditCostData } = useAdmin()

    function onChange(e: React.ChangeEvent<HTMLInputElement>) {
        const name = e.target.name
        const value = e.target.value
        setEditCostData((prevData) => ({...prevData, [name]: value}))
    }

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            const data = {
                id: editCostData!.id,
                name: editCostData!.name,
            }
            await AdminService.editCost(data)
            window.location.reload()
        } catch (error) {
            console.log(error)
            setMessage({
                type: 'error',
                content: 'Error updating car'
            })
            setTimeout(() => setMessage(undefined), 2500)
        }
    }

    return (
        <Modal onSubmit={onSubmit}>
            <h1>Edit cost</h1>
            <GeneralInput
            name="name"
            label="Name"
            placeholder="Lunch"
            value={editCostData?.name || ''}
            onChange={onChange}
            style={{width: '100%', marginBottom: '15px'}}
            />
            <div className="actions">
                <button type="submit" className="save">Save</button>
            </div>
            <div className="close">
                <AiFillCloseCircle onClick={() => setEditCostData(undefined)}/>
            </div>
        </Modal>
    )
}